// @flow
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { StepHeader, StepWrapper } from 'modules/configure/common/Steps';
import { actions, selectors } from 'modules/configure';
import TermsSelect from 'modules/configure/terms/TermsSelect';
import TermsTooltip from 'modules/configure/terms/TermsTooltip';
import t from 'modules/i18n/intl';
import { checkFeatureGate, FeatureFlags } from '../../../util/statsig';

import type { TermOption } from 'model/TermOption';
import selectCurrency from 'modules/cart/duck/selectors/currency';

type OwnProps = {
  isPeriod?: boolean;
};

const termsName = (period: boolean, subscription: boolean) => {
  if (period) {
    return t('purchase.choose-your-subscription-period');
  }
  if (subscription) {
    return t('purchase.choose-your-subscription-term');
  }
  return t('purchase.choose-your-maintenance-period');
};

const TermsStep = ({ isPeriod = false }: OwnProps) => {
  const dispatch = useDispatch();

  const isLimitDCMultiYearContractsFFON = checkFeatureGate(
    FeatureFlags.CART_LIMIT_DC_MULTI_YEAR_CONTRACTS,
  );

  const termOptions: TermOption[] = useSelector((state) =>
    selectors.selectTermOptions(state, isLimitDCMultiYearContractsFFON),
  );
  const term: TermOption | null = useSelector(selectors.selectTerm);
  const subscription: boolean = useSelector(selectors.isSubscription);
  const currency: string = useSelector(selectCurrency).result;

  const onTermSelect = (termParam) => dispatch(actions.setTerm(termParam));

  return (
    <StepWrapper>
      <StepHeader>
        {termsName(isPeriod === true, subscription)};
        {isPeriod ? null : <TermsTooltip subscription={subscription} />}
      </StepHeader>
      <TermsSelect
        options={termOptions}
        selected={term}
        onChange={onTermSelect}
        currency={currency}
      />
    </StepWrapper>
  );
};

export default TermsStep;
